import Vue from 'vue'
import AppToast from '@/components/AppToast.vue'

let instance = null

function getOrCreateInstance() {
  if (!instance) {
    const ToastConstructor = Vue.extend(AppToast)
    instance = new ToastConstructor()
    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)
  }
  return instance
}

const toast = {
  show(type, message, timeout = 4000) {
    getOrCreateInstance().add({ type, message, timeout })
  },
  success(message, timeout) {
    this.show('success', message, timeout)
  },
  error(message, timeout) {
    this.show('error', message, timeout)
  },
  warning(message, timeout) {
    this.show('warning', message, timeout)
  },
  info(message, timeout) {
    this.show('info', message, timeout)
  },
}

export default {
  install(Vue) {
    Vue.prototype.$toast = toast
  },
}

export { toast }
